module.exports = __webpack_public_path__ + "static/media/login_image.dfa383ed.png";